export type SendResetPasswordEmailResult = {
    data: {
        sendResetPasswordEmail: boolean | null;
    };
};

export const sendResetPasswordEmailMutation = `
  mutation SendResetPasswordEmail($email: String!, $callBackUrl: String!) {
    sendResetPasswordEmail(email: $email, callBackUrl: $callBackUrl)
  }
`;